import { Avatar, Box, styled } from '@mui/material'
import { useTranslation } from 'react-i18next'

const SmallAvatar = styled(Avatar)(({ theme }) => ({
    width: '16px',
    height: '16px',
    boxShadow: 'rgb(110 110 111) 0px 0px 8px 0px',
}))

const AvatarContainer = styled(Box)({
    '& .MuiAvatar-root:first-of-type': {
        marginLeft: '0px',
    },
})

const OwnerLink = styled(Box)({
    color: '#0057A0',
    fontSize: '13px',
    display: 'flex',
    alignItems: 'center',
    textDecoration: 'underline',
    zIndex: 10,
    '&:hover': {
        cursor: 'pointer',
        textDecoration: 'underline',
    },
    margin: '0px 8px',
})

export const OwnerGroup = ({ open = false, setOpen }) => {
    const { t } = useTranslation()

    return (
        <AvatarContainer display="flex" alignItems="center">
            <SmallAvatar />
            <SmallAvatar />
            <SmallAvatar />
            <SmallAvatar />
            <SmallAvatar />
            <OwnerLink
                onClick={setOpen}
                id="toggleShowOwners"
                role="button"
                aria-label={!open ? t('ShowOwners') : t('HideOwners')}
                tabIndex={0}
                onKeyDown={(e) => {
                    if (e.key === 'Enter' || e.key === ' ') {
                        e.preventDefault()
                        setOpen()
                    }
                }}
            >
                {!open ? t('ShowOwners') : t('HideOwners')}
            </OwnerLink>
        </AvatarContainer>
    )
}
